import styled from 'styled-components'

const MyDiv = styled.div`
.cards{
 border: 1px solid rgba(0, 0, 0, 0.15);
 border-radius: 8px;
 background: #fff;
 padding: 12px 6px 6px 6px;
  box-shadow:  0px 4px 4px 0px #00000040;
;
}
  .btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
.view{
  text-decoration: underline;
  color: #006838;
  cursor: pointer;
  }
`
export default MyDiv
